enum ActionType {
    REQUEST_INCIDENT_TYPES = '[INCIDENT_TYPES] REQUEST DATA',
    RECEIVED_INCIDENT_TYPES = '[INCIDENT_TYPES] RECEIVE DATA',
}

export default ActionType
